import { useEffect, useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import { apiService } from "_helpers";
import axios from 'axios';

export function CenterStudyRateModal({
  show,
  onClose,
  centerData,
}) {
  
  const [formData, setFormData] = useState(centerData || {});
  const [studyRateList, setStudyRateListData] = useState([]);
  const [attachment, setAttachment] = useState(null);
  const [attachmentPath, setAttachmentPath] = useState("");

  const authUser = useSelector(x => x.auth.user);
  const dispatch = useDispatch();

  useEffect(() => {
      const fetchData = async () => {
        await Promise.all([getStudyRateList()]);
      };
      fetchData();
    }, []);

    function randomNumberInRange(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    const handleAttachmentChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // size validation
    if (file.size > 5 * 1024 * 1024) {
      alert("File size must be under 5MB");
      return;
    }

    setAttachment(file);
  };

  const handlePreviewAttachment = () => {
    if (attachment) {
      // Before upload (local file)
      const blobUrl = URL.createObjectURL(attachment);
      window.open(blobUrl, "_blank");
      return;
    }

    if (attachmentPath) {
      // After upload (server file)
      window.open(
        `${process.env.REACT_APP_API_URL}/${attachmentPath}`,
        "_blank"
      );
    }
  };
  const getAttachmentName = () => {
    if (attachment) return attachment.name;

    if (attachmentPath) {
      return attachmentPath.split("/").pop(); // extract filename
    }

    return "";
  };
  const removeAttachment = () => {
    setAttachment(null);
    setAttachmentPath("");
  };

const handleRateChange = (rateKey, name, newValue) => {  
  
  setStudyRateListData(prevData => 
    prevData.map(item => 
      item.rate_key === rateKey 
        ? { ...item, [name]: newValue } 
        : item
    )
  );

  setTimeout(function() {
    handleRateChange(rateKey, 'action_flag', "U");
  }, 100);

};
  
  const getStudyRateList = async () => {
    const center_key = formData.center_key;
    const url = `${process.env.REACT_APP_API_URL}/center/GetCenterRateList?center_key=`+center_key.toString();
    const data = await apiService.get(url, dispatch);
    if (Array.isArray(data) && data.length > 0) {
      setStudyRateListData(data);
    }
  };
  const onSave = async () => {    
    try {
      const url = `${process.env.REACT_APP_API_URL}/center/UpdateCenterRate`;      
      let filteredData = studyRateList.filter((item) => {
            return item.action_flag !== " ";
        });

      const formData = new FormData();
      if (attachment) {
          formData.append("attachment", attachment);
      }
      else{
          if(filteredData.length===0){
            alert('Nothing changes to update');
            return;
          }
      }

      filteredData.forEach((item, index) => {
        formData.append(`CenterRateList[${index}].center_key`, item.center_key);
        formData.append(`CenterRateList[${index}].rate_key`, item.rate_key);        
        formData.append(`CenterRateList[${index}].single_service_rate`, item.single_service_rate);        
        formData.append(`CenterRateList[${index}].double_service_rate`, item.double_service_rate);        
        formData.append(`CenterRateList[${index}].action_flag`, item.action_flag);        
      });

      const user_key = authUser?.user_key;
      const request_id = randomNumberInRange(1000000, 9000000);
      const user = JSON.parse(localStorage.getItem("user"));
      const token = user?.token || null;

       const response = await axios.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`,
            'user_key': user_key.toString(),
            'request_id': request_id.toString(),
          },
        });
      
      if (response?.status === 200) {        
        getStudyRateList();

        alert("Center rate updated successfully.");
      } else {
        alert("Failed to update center rate. Please try again.");
      }
    } catch (error) {
      alert("An error occurred while updating center rate.");
    }
  }

  return (
    <div className="centered-modal" style={{zIndex:"21056"}}>
      
      <div className="modal-header pt-2">
          <span className="close" id="close-button" onClick={onClose}>&times;</span>
          <h6 className="mb-0"><i className="bi bi-person-circle"></i> Center Study Rate: {formData?.center_name}</h6>
      </div>
      <div className="modal-body" style={{paddingTop:"0.5px"}}>
        <div className="row justify-content-center pb-1">
                        <div className="col-lg-12 col-12 ps-1 pe-1">
                            {!(attachment || attachmentPath) ? (
                              <label className="attach-btn">
                                📎 Attach File
                                <input
                                  type="file"
                                  hidden
                                  accept=".pdf,.jpg,.jpeg,.png"
                                  onChange={handleAttachmentChange}
                                />
                              </label>
                            ) : (
                              <div className="attached-file">
                                {/* Click to preview */}
                                <span
                                  className="file-name"
                                  style={{ cursor: "pointer", color: "#0d6efd" }}
                                  onClick={handlePreviewAttachment}
                                  title="Click to preview"
                                >
                                  {getAttachmentName()}
                                </span>

                                {/* Remove */}
                                <button
                                  type="button"
                                  className="remove-file"
                                  onClick={removeAttachment}
                                >
                                  ✕
                                </button>
                              </div>
                            )}

                        </div>
                  </div>
        <div className="row">
            <div className="col-md-12 mb-2">
              <div className="card">
                <div className="card-header bg-gradient-1 text-light">
                  {/* Table Heading */}
                  <div className="row">
                    <div className="col-2 col-sm-2 col-md-1">
                      <p className="tele-table-heading">
                        Id
                      </p>
                    </div>
                    <div className="col-1 col-sm-1 col-md-1">
                      <p className="tele-table-heading">
                        Modality
                      </p>
                    </div>
                    <div className="col-2 col-sm-2 col-md-1">
                      <p className="tele-table-heading">Type</p>
                    </div>
                    <div className="col-3 col-sm-3 col-md-3">
                      <p className="tele-table-heading">
                        Study Name
                      </p>
                    </div>
                    <div className="col-2 col-sm-2 col-md-2">
                      <p className="tele-table-heading">Single</p>
                    </div>
                    <div className="col-2 col-sm-2 col-md-2">
                      <p className="tele-table-heading">Double</p>
                    </div>
                    <div className="col-2 col-sm-2 col-md-2 d-none d-sm-block">
                      <p className="tele-table-heading">Last Update</p>
                    </div>
                  </div>
                </div>
                <div className="card-body tele-table-padding rate-studylist-area">
                  {/* tele-table-rowbg1 */}
                  <div className="row centerlist" id="divStudyRate"></div>
                  {studyRateList.map((data, i) => (
                    <div key={i} className="row align-items-center studylist">
                      <div className="col-2 col-sm-2 col-md-1">
                        <p className="tele-table-dash-text">{data.rate_key}</p>
                      </div>
                      <div className="col-1 col-sm-1 col-md-1">
                        <p className="tele-table-dash-text">{data.modality}</p>
                      </div>
                      <div className="col-2 col-sm-2 col-md-1">
                        <p className="tele-table-dash-text">{data.rate_type}</p>
                      </div>
                      <div className="col-3 col-sm-3 col-md-3">
                        <p className="tele-table-dash-text">{data.rate_name}</p>
                      </div>
                      <div className="col-2 col-sm-2 col-md-2">
                        <p className="tele-table-dash-text">
                          <input
                            type="number"
                            id={"txt"+data.rate_key.toString() + "_single"}
                            className="form-control"
                            defaultValue={data.single_service_rate}
                            onChange={(e) => handleRateChange(data.rate_key, 'single_service_rate', e.target.value)}
                          ></input>
                        </p>
                      </div>
                      <div className="col-2 col-sm-2 col-md-2">
                        <p className="tele-table-dash-text">
                          {(data.double_service_rate === null ? 
                              <input
                                type="number"
                                id={"txt"+data.rate_key.toString() + "_double"}
                                className="form-control"
                                tabIndex="-1"
                                style={{backgroundColor:"lightgrey"}}
                                readOnly                                
                              ></input>
                            : 
                              <input
                                type="number"
                                id={"txt"+data.rate_key.toString() + "_double"}
                                className="form-control"
                                defaultValue={data.double_service_rate}
                                onChange={(e) => handleRateChange(data.rate_key, 'double_service_rate', e.target.value)}
                              ></input>
                          )}
                        </p>
                      </div>
                      <div className="col-4 col-sm-2 col-md-2">
                        <p className="tele-table-dash-text">
                          {data.updated_on ? 
                            new Intl.DateTimeFormat('en-GB', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: false
                            }).format(new Date(data.updated_on)).replace(',', '').replace(/\//g, '-') 
                            : ''}
                        </p>
                      </div>

                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        
      </div>

      <div className="modal-actions" style={{marginTop:"0px"}}>
        
        <div className="col-lg-4 col-4"><button type="button"
                className="btn btn-secondary btn-sm btn-block bi bi-save2-fill" id="btnStudyRateSave" onClick={() => onSave()}> SAVE</button></div>
        <div className="col-lg-3 col-4"><button type="button"
                className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnStudyRateClose" onClick={onClose}> CLOSE</button></div>
      </div>
    </div>
  );
}
